import React from 'react';
import "../../../styles.css";
import audioimg from '../../../assets/audio-waves.png';
import returnimg from '../../../assets/undo.png';
import { Link } from "react-router-dom";
import sphoneme from '../../../assets/phonemes/s.mp3'
import mphoneme from '../../../assets/phonemes/m.mp3'
import tphoneme from '../../../assets/phonemes/t.mp3'
import pphoneme from '../../../assets/phonemes/p.mp3'
import nphoneme from '../../../assets/phonemes/n.mp3'
import cphoneme from '../../../assets/phonemes/c.mp3'
import kphoneme from '../../../assets/phonemes/k.mp3'
import rphoneme from '../../../assets/phonemes/r.mp3'
import bphoneme from '../../../assets/phonemes/b.mp3'
import jphoneme from '../../../assets/phonemes/j.mp3'
import fphoneme from '../../../assets/phonemes/f.mp3'
import gphoneme from '../../../assets/phonemes/g.mp3'
import hphoneme from '../../../assets/phonemes/h.mp3'
import dphoneme from '../../../assets/phonemes/d.mp3'
import wphoneme from '../../../assets/phonemes/w.mp3'
import vphoneme from '../../../assets/phonemes/v.mp3'
import lphoneme from '../../../assets/phonemes/l.mp3'
import yphoneme from '../../../assets/phonemes/y.mp3'
import simg from '../../../assets/real_assets/s.jpg'
import mimg from '../../../assets/real_assets/m.jpg'
import timg from '../../../assets/real_assets/t.jpg'
import pimg from '../../../assets/real_assets/p.jpg'
import nimg from '../../../assets/real_assets/n.jpg'
import cimg from '../../../assets/real_assets/c.jpg'
import kimg from '../../../assets/real_assets/k.jpg'
import rimg from '../../../assets/real_assets/r.jpg'
import bimg from '../../../assets/real_assets/b.jpg'
import jimg from '../../../assets/real_assets/j.jpg'
import fimg from '../../../assets/real_assets/f.jpg'
import gimg from '../../../assets/real_assets/g.jpg'
import himg from '../../../assets/real_assets/h.jpg'
import dimg from '../../../assets/real_assets/d.jpg'
import wimg from '../../../assets/real_assets/w.jpg'
import vimg from '../../../assets/real_assets/v.jpg'
import limg from '../../../assets/real_assets/l.jpg'
import yimg from '../../../assets/real_assets/y.jpg'
// import simg from '../../../assets/animals/S/snake.png'
// import mimg from '../../../assets/animals/M/monkey.png'
// import timg from '../../../assets/animals/T/turtle.png'
// import pimg from '../../../assets/animals/P/panda.png';
// import nimg from '../../../assets/animals/N/narwhal.png';
// import cimg from '../../../assets/animals/C/cat.png';
// import kimg from '../../../assets/animals/K/kangaroo.png';
// import rimg from '../../../assets/animals/R/rhinoceros.png';
// import bimg from '../../../assets/animals/B/bee.png';
// import jimg from '../../../assets/animals/J/jellyfish.png';
// import fimg from '../../../assets/animals/F/fish.png';
// import gimg from '../../../assets/animals/G/gorilla.png';
// import himg from '../../../assets/animals/H/hippopotamus.png';
// import dimg from '../../../assets/animals/D/duck.png';
// import wimg from '../../../assets/animals/W/wolf.png';
// import vimg from '../../../assets/animals/V/vulture.png';
// import limg from '../../../assets/animals/L/lion.png';
// import yimg from '../../../assets/animals/Y/yak.png';
// import aimg from '../../../assets/animals/A/ant.png';
// import chimg from '../../../assets/animals/CH/chicken.png';
// import eimg from '../../../assets/animals/E/elephant.png';
// import iimg from '../../../assets/animals/I/iguana.png';
// import oimg from '../../../assets/animals/O/octopus.png';
// import shimg from '../../../assets/animals/SH/sheep.png';
// import zimg from '../../../assets/animals/Z/zebra.png';

const animalImages = {
    's': simg,
    'm': mimg,
    't': timg,
    'p': pimg,
    'n': nimg,
    'c': cimg,
    'k': kimg,
    'r': rimg,
    'b': bimg,
    'j': jimg,
    'f': fimg,
    'g': gimg,
    'h': himg,
    'd': dimg,
    'w': wimg,
    'v': vimg,
    'l': limg,
    'y': yimg
}

const sounds = {
    's': sphoneme,
    'm': mphoneme,
    't': tphoneme,
    'p': pphoneme,
    'n': nphoneme,
    'c': cphoneme,
    'k': kphoneme,
    'r': rphoneme,
    'b': bphoneme,
    'j': jphoneme,
    'f': fphoneme,
    'g': gphoneme,
    'h': hphoneme,
    'd': dphoneme,
    'w': wphoneme,
    'v': vphoneme,
    'l': lphoneme,
    'y': yphoneme
}

function AnimalQuestion(props) {
    const audio = new Audio(sounds[props.letter])
    return (
        <div className='question'>
            <Link to='/Level Select' className='leftButton'><img className='imagesInDivs' src={returnimg} alt="BACK" onClick={() => props.resetVariables()} /></Link>
            <div className='questionImage'>
                <img src={animalImages[props.letter]} className='photographsInDivs' alt='Object' />
            </div>
            <button className='rightButton'><img className='imagesInDivs' src={audioimg} alt="AUDIO" onClick={handleAudio} /></button>
        </div>
    );

    function handleAudio() {
        audio.play();
    }
}

export default AnimalQuestion;